<template>
  <v-app>

    <v-container fluid style="padding: 0px;">
      <component v-bind:is="pagina">
      </component>
    </v-container>

    <datAlert></datAlert>
    <ShpSnackbar></ShpSnackbar>
  </v-app>
</template>



<script>
import ShpApp from '@/components/ShpApp'
import ShpSnackbar from '@/components/Alerts/ShpSnackbar'
import datAlert from '@/components_datadec/datAlert'

export default {
  name: 'App',
  components: {
    ShpApp,
    ShpSnackbar,
    datAlert
  },
  data() {
    return {
      pagina: ShpApp,
      url: '/',
      dVersion: '',
      refreshing: false,
    }
  },
  beforeCreate() {
    // CMARIN
    // Para los casos en los que nos logueamos desde fuera como la tienda está llegando el token anterior y no se está limpiando en el accesWithToken como debería,
    // por lo que las llamadas devuelven un error 401.
    // La única forma que hemos visto Julio y yo es comprobar que si llamo desde url externa, es decir, llamo /login/:pToken, entonces debo limpiar las variables
    //
    const tokenLogin = this.$route.params.pToken;
    // 
    if (tokenLogin) {
      this.$store.commit('removeAutenticacion');
    }
  },
  created() {
    this.registerSW();
  },
  async accept() {
    this.showUpdateUI = false;
    await this.$workbox.messageSW({ type: "SKIP_WAITING" });
  },
  methods: {
    showRefreshUI() {
      // Muestra una ventana modal preguntando al usuario si quiere recargar la página.
      console.log("Ruta actual:", this.$route.path);
      if (this.$route.path !== '/') {
        const alert = {
          text: this.$t('nuevaVersion'),
          action: () => { window.location.reload() },
          icon: 'mdi-reload',
          type: 'warning'
        }
        this.$bus.$emit('showAlert', alert)
      }
      else {
        window.location.reload()
      }

    },
    fInitSession() {
      if (sessionStorage.getItem('userData') !== undefined && sessionStorage.getItem('userData') !== null) {
        this.$store.commit('setUserData', JSON.parse(sessionStorage.getItem('userData')))
      }
    },
    registerSW() {
      // Si el nevegador tiene permitido el uso de Service Worker, activamos el evento
      // y quedamos a la espera de una nueva versión del programa.
      // 
      if ("serviceWorker" in navigator) {
        window.addEventListener("load", () => {
          navigator.serviceWorker.register("/static/service_worker.js")
            .then(reg => {

              if (reg.waiting) {
                this.updateReady(reg.waiting);
              }

              if (reg.installing) {
                this.trackInstalling(reg.installing);
              }

              reg.addEventListener('updatefound', () => {
                this.trackInstalling(reg.installing);
              });
              // Al iniciar la aplicación, miramos si se ha actualizado
              reg.update();
              // Verificar actualizaciones cada 1h
              setInterval(() => {
                reg.update();
              }, 3600000); // 1h
            })
            .catch(err => {
              console.log("Service Worker: ERROR:", err);
            });
        });
      }
    },
    trackInstalling(worker) {
      worker.addEventListener('statechange', () => {
        if (worker.state === 'installed') {
          this.updateReady(worker);
        }
      });
    },
    updateReady(worker) {
      worker.postMessage({ type: 'SKIP_WAITING' });
      // 
      worker.addEventListener('statechange', () => {
        if (worker.state === 'activated') {
          this.showRefreshUI()
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue